import { Auth } from 'aws-amplify';

const signUp = async (action) => {
  try {
    const { user } = await Auth.signUp({
      username: action.accountRequest.email,
      password: action.accountRequest.password,
      attributes: {
        email: action.accountRequest.email,
        phone_number: action.accountRequest.phone.replace(' ', ''),
        given_name: action.accountRequest.firstName,
        family_name: action.accountRequest.lastName
      }
    });
    console.log('return from aws signup: ', user);
    return user;
  } catch (e) {
    console.log('awsUserSignup:signUp - Error signing up: ', e);
    return e;
  }
};

const confirmSignUp = async (action) => {
  try {
    var userInfo = await Auth.confirmSignUp(action.email, action.code);
    return userInfo;
  } catch (e) {
    console.log('awsUserSignup:confirmSignUp - Error signing up: ', e);
    return e;
  }
};

const resendSignUp = async (action) => {
  try {
    var userInfo = await Auth.resendSignUp(action.email);
    return userInfo;
  } catch (e) {
    console.log('awsUserSignup:resendSignUp - Error signing up: ', e);
    return e;
  }
};

const removeAccount = async () => {
  try {
    var user = await Auth.currentAuthenticatedUser();
    user.deleteUser();
  } catch (e) {
    console.log('awsUserSignup: removeAccount - Error deleting user: ', e);
    return e;
  }
};
export default { signUp, confirmSignUp, resendSignUp, removeAccount };
